// Ordered stage names of a job application's company pipeline, and where the application is in it.
// Copies before sorting: sort() mutates, and pipeline_stages comes straight from component state.
export const getAppPipeline = (app) => {
  const stages = [...(app.pipeline_stages || [])]
    .sort((a, b) => a.position - b.position)
    .map((s) => s.name);
  if (stages.length === 0) return { stages: [], current: -1, total: 0 };
  const currentIdx = stages.findIndex((name) => name === app.stage_name);
  return { stages, current: currentIdx >= 0 ? currentIdx : 0, total: stages.length };
};
